<template>
  <div class="pagination" v-if="config.pages > 1">
    <button class="pagination__button" @click="goToPage(1)" v-text="'<<'"></button>
    <button class="pagination__button" v-for="(button, index) in buttons" :class="{'pagination__button--active': page == button}" :key="index" v-text="button" @click="goToPage(button)"></button>
    <button class="pagination__button" @click="goToPage(config.pages)" v-text="'>>'"></button>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      required: true,
      default: function () {
        return {
          pages: 10,
          results: 55,
          currentPage: 1,
          maxButtons: 8
        }
      }
    }
  },
  data: function () {
    return {
      buttons: null
    }
  },
  created: function () {
    this.createButtons()
  },
  watch: {
    '$route.path': function () {
      this.createButtons()
    }
  },
  methods: {
    goToPage: function (page) {
      this.config.currentPage = page
      let params = this.$route.params
      params.page = page
      this.$router.push({
        name: this.$route.name,
        params: params
      })
    },
    createButtons: function () {
      let buttons = []
      let pagBtns = (this.config.pages < this.config.maxButtons) ? this.config.pages : this.config.maxButtons
      let firstPage = this.config.currentPage - Math.floor(pagBtns / 2)
      let lastPage = this.config.currentPage + Math.ceil(pagBtns / 2) - 1
      if (firstPage < 1) {
        firstPage = 1
        lastPage = firstPage + pagBtns - 1
      } else if (lastPage > this.config.pages) {
        lastPage = this.config.pages
        firstPage = lastPage - pagBtns + 1
      }

      for (var i = firstPage; i <= lastPage; i++) {
        buttons.push(i)
      }
      this.buttons = buttons
    }
  },
  computed: {
    page: function () {
      return this.$route.params.page
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../assets/sass/components/layout/_pagination"
</style>



// WEBPACK FOOTER //
// src/components/layout/pagination.vue